import {ORDER_PRODUCT_FILE_PUSH, ORDER_PRODUCT_FILE_REMOVE} from './constants';

export const pushUploadingFile = (productCode: string, hashes: string[]) => ({
    type: ORDER_PRODUCT_FILE_PUSH,
    payload: {productCode, hashes},
});
export const removeUploadingFile = (productCode: string, hashes: string[]) => ({
    type: ORDER_PRODUCT_FILE_REMOVE,
    payload: {productCode, hashes},
});
